export default __webpack_public_path__ + "static/media/IM.4fd71378.svg";